export const submissionEmailValidationInitialState = {
  email: '',
  isValidEmail: true,
  isSubmitting: false,
  error: null as string
}

export type SubmissionEmailValidationState = typeof submissionEmailValidationInitialState
